var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ty-footer-one"},[_c('div',[_c('mt-button',{attrs:{"type":_vm.type,"size":"large"},on:{"click":_vm.callback}},[_vm._v(_vm._s(_vm.buttonName))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94e79cf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ty-footer-one-button/TyFooterOneButton.vue
// module id = 330
// module chunks = 0